import React from 'react';
import { AntModal, Button } from '../../../../../components';
import { message } from 'antd';
import { Location } from '../utils';

type AssessedIntermediateDependencies = {
  totalCount: number;
  hasDependencies: boolean;
  directDependenciesCount: number;
  indirectDependenciesCount: number;
  sampleDependencies: Location[];
  parentLocationMapping: {
    location: Location;
    dependencyId: string;
  }[];
};

type RemoveLocationsModalProps = {
  openModal: boolean;
  onCancel: () => void;
  divisionId: string;
  locationsToBeRemoved: { uuid: string }[];
  assessedIntermediateDependencies?: AssessedIntermediateDependencies;
  onCleanup: () => void;
  onUncheckLocation: (variables: any) => Promise<any>;
};

export const RemoveLocationsModal: React.FC<RemoveLocationsModalProps> = ({
  openModal,
  onCancel,
  divisionId,
  locationsToBeRemoved,
  assessedIntermediateDependencies,
  onCleanup,
  onUncheckLocation,
}) => {
  return (
    <AntModal
      title={`Warning: Locations have dependencies`}
      openModal={openModal}
      onCancel={onCancel}
      width={600}
      footer={
        <div className="flex justify-end mt-4 gap-4">
          <Button type="primary" onClick={onCleanup}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={async () => {
              try {
                await onUncheckLocation({
                  variables: {
                    input: {
                      locations: locationsToBeRemoved,
                      division: { uuid: divisionId },
                      level: 0,
                    },
                  },
                });
                message.success('Locations removed successfully');
                onCleanup();
              } catch (error) {
                message.error('Failed to remove locations');
              }
            }}
          >
            Proceed with Removal
          </Button>
        </div>
      }
    >
      <div className="space-y-4">
        <p className="text-base">
          {assessedIntermediateDependencies?.hasDependencies ? (
            <>
              Removing the selected {locationsToBeRemoved.length} location
              {locationsToBeRemoved.length > 1 ? 's' : ''} from the dependency
              mapping will also unmap any locations that the selected location
              {locationsToBeRemoved.length > 1 ? 's are' : ' is'} reliant on.
              Are you sure you want to continue?
            </>
          ) : (
            <>
              Are you sure you want to remove {locationsToBeRemoved.length}{' '}
              location
              {locationsToBeRemoved.length > 1 ? 's' : ''}?
            </>
          )}
        </p>
        {assessedIntermediateDependencies?.hasDependencies && (
          <ul className="list-disc list-inside">
            {assessedIntermediateDependencies?.sampleDependencies.map(
              (dependency) => (
                <li key={dependency.uuid} className="text-base text-gray-800">
                  {dependency.locationName}
                </li>
              ),
            )}
          </ul>
        )}
      </div>
    </AntModal>
  );
};
